import React from "react";
import { FadeUp } from "../motion/Reveal";
import { ArrowUpRight } from "lucide-react";

const WORKS = [
    {
        client: "Fintech Aurora",
        title: "App de investimentos",
        result: "R$ 4.2M movimentados no 1º mês",
        img: "https://images.unsplash.com/photo-1551650975-87deedd944c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxhcHAlMjBkZXZlbG9wbWVudCUyMGludGVyZmFjZXxlbnwwfHx8fDE3ODQ3MjkzNDV8MA&ixlib=rb-4.1.0&q=85",
        tag: "APP · FINTECH",
    },
    {
        client: "LogiTech Brasil",
        title: "Portal B2B + Automação",
        result: "-62% em tempo de cotação",
        img: "https://images.unsplash.com/photo-1607799279861-4dd421887fb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxhcHAlMjBkZXZlbG9wbWVudCUyMGludGVyZmFjZXxlbnwwfHx8fDE3ODQ3MjkzNDV8MA&ixlib=rb-4.1.0&q=85",
        tag: "WEB · LOGÍSTICA",
    },
    {
        client: "MediCore",
        title: "Copilot com IA para clínicas",
        result: "40h/mês economizadas por médico",
        img: "https://images.pexels.com/photos/28494632/pexels-photo-28494632.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        tag: "IA · HEALTHTECH",
    },
    {
        client: "Vertex Retail",
        title: "E-commerce headless",
        result: "+180% em conversão mobile",
        img: "https://images.unsplash.com/photo-1760344594784-60ff14035eb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxncmVlbiUyMHRlY2glMjBhYnN0cmFjdHxlbnwwfHx8fDE3ODQ3MjkzNDR8MA&ixlib=rb-4.1.0&q=85",
        tag: "WEB · E-COMMERCE",
    },
];

export default function Works() {
    return (
        <section
            id="trabalhos"
            className="relative py-32 md:py-40 border-b border-white/10"
            data-testid="works-section"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-10">
                <div className="flex items-end justify-between mb-16 flex-wrap gap-8">
                    <FadeUp>
                        <span className="font-mono-tech text-xs tracking-widest text-[#00FF66] uppercase">
                            (Trabalhos selecionados)
                        </span>
                        <h2 className="mt-4 font-display uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tighter text-white">
                            Casos que
                            <br />
                            <span className="text-white/40">deram lucro.</span>
                        </h2>
                    </FadeUp>
                    <FadeUp delay={0.1}>
                        <a
                            href="#contato"
                            className="btn-ghost"
                            data-testid="works-cta-more"
                        >
                            Ver portfólio completo
                            <ArrowUpRight className="w-4 h-4" />
                        </a>
                    </FadeUp>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
                    {WORKS.map((w, i) => (
                        <FadeUp key={w.title} delay={i * 0.08}>
                            <a
                                href="#contato"
                                className="group block"
                                data-testid={`work-card-${i}`}
                            >
                                <div
                                    className={`relative overflow-hidden clip-frame ${
                                        i % 2 === 0
                                            ? "aspect-[4/3]"
                                            : "aspect-[5/4] md:mt-16"
                                    }`}
                                >
                                    <img
                                        src={w.img}
                                        alt={w.title}
                                        className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-[900ms] scale-105 group-hover:scale-110"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/80 via-transparent to-transparent" />
                                    <div className="absolute top-6 left-6 flex items-center gap-2 font-mono-tech text-[10px] tracking-widest text-white/80 bg-black/40 backdrop-blur-md border border-white/10 px-3 py-1.5 rounded-full">
                                        <span className="w-1.5 h-1.5 rounded-full bg-[#00FF66]" />
                                        {w.tag}
                                    </div>
                                </div>
                                <div className="mt-6 flex items-start justify-between gap-6">
                                    <div>
                                        <div className="font-mono-tech text-xs text-white/50 uppercase tracking-widest mb-2">
                                            {w.client}
                                        </div>
                                        <h3 className="font-display uppercase text-2xl md:text-3xl text-white tracking-tight">
                                            {w.title}
                                        </h3>
                                        <div className="mt-3 text-[#00FF66] font-mono-tech text-sm">
                                            → {w.result}
                                        </div>
                                    </div>
                                    <ArrowUpRight
                                        className="w-6 h-6 text-white/40 group-hover:text-[#00FF66] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all shrink-0"
                                        strokeWidth={1.5}
                                    />
                                </div>
                            </a>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
